// src/pages/Today.js
import React, { useState, useEffect } from "react";
import Typography from "../components/Typography";
import { spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";
import { useQueue } from "../context/QueueContext";

import SplitText from "../components/SplitText";
import BlurText from "../components/BlurText";
import DecryptedText from "../components/DecryptedText";


function Tiange(){

    const handleAnimationComplete = () => {
        console.log('All letters have animated!');
      };
    
    const styles={
        response: {
            display: "flex",
            flexDirection: "column",
            gap: spacing.l,
            height: "100%",
            padding: spacing.l,
            boxSizing: "border-box",
            width: "fit-content",
            textAlign: "left",
    },
    }

    return (
        <div style={styles.response}>
            <Typography variant="headlineS" type="editorial">
                Split Text Reveal
            </Typography>
            <SplitText
                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                className="text-2xl font-semibold"
                style={{ textAlign: "left" }} 
                delay={20}
                animationFrom={{ opacity: 0, transform: 'translate3d(0,20px,0)' }}
                animationTo={{ opacity: 1, transform: 'translate3d(0,0,0)' }}
                easing="easeOutCubic"
                threshold={0.2}
                rootMargin="-50px"
                textAlign = 'left'
                typographyVariant = "summary" // default typography variant
                typographyType = "editorial" // default typography type
                onLetterAnimationComplete={handleAnimationComplete}
            />
            <Typography variant="headlineS" type="editorial">
                Blur Text Reveal
            </Typography>
            <BlurText
                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                delay={20}
                animateBy="words"
                direction="top"
                onAnimationComplete={handleAnimationComplete}
                className="text-2xl mb-8"
            />
            <Typography variant="headlineS" type="editorial">
                Decrypted Text Reveal
            </Typography>
            <DecryptedText
                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                speed={100}
                maxIterations={20}
                characters="ABCD1234!?"
                className="revealed"
                parentClassName="all-letters"
                encryptedClassName="encrypted"
                animateOn="view"
            />
        </div>
    );
}

export default Tiange;